import http from 'hub-http/clients/apiClient';
import { FlpPermissions } from 'automation-ui-permissions/flp/models/EnumedFlowPermissions';
export const mapRawPermissionsToEnumedPermissions = permissions => {
  return new FlpPermissions(permissions);
};
const getShouldUseMockFlpData = () => {
  try {
    return !!localStorage.getItem('use-flp-modulo-arithmetic');
  } catch (error) {
    console.error('Error accessing localStorage:', error);
    return false;
  }
};
const getMockFlpResponse = flowIds => {
  const results = flowIds.map(flowId => {
    const hasViewPermission = flowId % 2 === 0;
    const hasEditPermission = flowId % 3 === 0;
    const hasDeletePermission = flowId % 4 === 0;
    const hasSomeRestriction = !hasViewPermission || !hasEditPermission || !hasDeletePermission;
    return {
      flowId,
      hasViewPermission,
      hasEditPermission,
      hasDeletePermission,
      fieldLevelPermissionReasons: hasSomeRestriction ? [{
        objectTypeId: '0-1',
        propertyName: 'hubspot_owner_id',
        fieldLevelPermission: hasViewPermission ? 'READ_ONLY' : 'HIDDEN',
        referencedBy: 'enrollmentCriteria'
      }, {
        objectTypeId: '0-1',
        propertyName: 'currentlyinworkflow',
        fieldLevelPermission: hasViewPermission ? 'READ_ONLY' : 'HIDDEN',
        referencedBy: 'enrollmentCriteria'
      }] : []
    };
  });
  return {
    status: 'COMPLETE',
    startedAt: new Date().toISOString(),
    completedAt: new Date().toISOString(),
    results
  };
};
export const fetchPermissionsForFlows = flowIds => {
  const shouldUseMockFlpData = getShouldUseMockFlpData();
  if (shouldUseMockFlpData) {
    const apiResponse = getMockFlpResponse(flowIds);
    return Promise.resolve(Object.assign({}, apiResponse, {
      results: apiResponse.results.map(mapRawPermissionsToEnumedPermissions)
    }));
  }
  return http.post('automationplatform/v1/access/permission-check/flow/batch/read', {
    data: {
      inputs: flowIds
    }
  }).then(response => ({
    results: response.results.map(mapRawPermissionsToEnumedPermissions)
  }));
};